/**
 * Avisos do sino (agenda v2, Fase 3). Backend: app `notificacoes`.
 *
 *   GET  /api/notificacoes          -> { nao_lidas, itens }
 *   GET  /api/notificacoes/resumo   -> { nao_lidas, ultima }  (o sino, a cada minuto)
 *   POST /api/notificacoes/lidas    -> { ids } | { tarefa_id } | { todas: true }
 */

const BASE = "/api/notificacoes";
const post = (corpo) => ({ method: "POST", body: JSON.stringify(corpo), silentError: true });

export const lerAvisos = (request) => request(BASE, { silentError: true });
export const lerResumoDosAvisos = (request) => request(`${BASE}/resumo`, { silentError: true });
export const marcarAvisosLidos = (request, ids) => request(`${BASE}/lidas`, post({ ids }));
export const marcarAvisosDaTarefa = (request, tarefaId) => request(`${BASE}/lidas`, post({ tarefa_id: tarefaId }));
export const marcarTodosOsAvisos = (request) => request(`${BASE}/lidas`, post({ todas: true }));

/** "/minhas-pendencias?tarefa=<id>" -> "<id>" (o link que o backend grava). */
export function tarefaDoLink(link) {
  try {
    return new URL(String(link || ""), "https://x.invalid").searchParams.get("tarefa");
  } catch {
    return null;
  }
}
